import React, { useState, useEffect } from "react";
import styles from "../../styles/components/softskillDetails.module.scss";
import Icons from "../../public/assets/svg";

import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import axios from "axios";
import Loader from "../Loader";
import endpoints from "../../utility/endpoints";
import SuccessModal from "../../pages/successModal";
import { saveCurrentBot } from "../../redux/storeBot/actions";
import Dropdown from "../listWithoutcheck";
import _ from "lodash";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import path from "path";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faQuoteLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

function index(props) {
  //console.log(props, "props at bot detail");
  //const routes = props.globalData.menu_component.menu_list;
  const [myBot, setMyBot] = React.useState(null);
  const dispatch = useDispatch();
  const router = useRouter(); //"businessUserRegionWise", // //"businessUserRegionWise",

  const [restrictedViewDetails, setRestrictedViewDetails] = useState(true);
  const restrictedUserDocumentView = [
    "businessUserRegionWise",
    "endUser",
    "businessOwner",
  ];

  const restrictedDocumentTypes = ["SOP", "PDD"];

  let documentAr = [
    { title: "SOP", value: "sopDocument", type: [".pdf", ".doc", ".docx"] },
    { title: "PDD", value: "pddDocument", type: [".pdf", ".doc", ".docx"] },
    {
      title: "PDD Approval",
      value: "pddApprovalDocument",
      type: [".msg", ".png"],
    },
    { title: "SDD", value: "sddDocument", type: [".pdf", ".doc", ".docx"] },
    { title: "QSG", value: "qsgDocument", type: [".doc", ".docx"] },
    { title: "ODI", value: "odiDocument", type: [".xlxs", ".xls"] },
    { title: "BRD", value: "brdDocument", type: [".xlxs", ".xls"] },
    {
      title: "Cost Apporval",
      value: "costApprovalDocument",
      type: [".msg", ".png"],
    },
    {
      title: "Landscape Approval",
      value: "explicitLandscapeApplicationOwnerApprovalDocument",
      type: ".msg",
    },
    {
      title: "GPM Approval",
      value: "explicitGPMApprovalSupplyChainFinanceDocument",
      type: [".msg", ".png"],
    },
    {
      title: "GFCF Approval",
      value: "explicitGFCFApprovalDocument",
      type: [".msg", ".png"],
    },
    {
      title: "Dev Quality Crendentails Available",
      value: "devQualityCredentialsAvailableDocument",
      type: ".msg",
    },
    {
      title: "Infosec Approval",
      value: "infosecApprovalDocument",
      type: ".msg",
    },
    {
      title: "DA Review Sign Off",
      value: "dAReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "Test Data Development",
      value: "testDataAvailableForDevelopmentDocument",
      type: [".xlxs", ".xls"],
    },
    {
      title: "Request Raised Product Credentials",
      value: "requestRaisedForProductionCredentialsDocument",
      type: ".msg",
    },
    {
      title: "Internal Testing Completed",
      value: "internalTestingCompletedDocument",
      type: ".msg",
    },
    {
      title: "Peer Review Sign Off",
      value: "peerReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "DA Review Second Sign Off",
      value: "daReviewSecondSignOffDocument",
      type: ".msg",
    },
    {
      title: "BP Release Sign Off",
      value: "bpReleaseSignOffFromDaDocument",
      type: ".msg",
    },
    {
      title: "UAT Scripts With Results",
      value: "uatScriptsWithResultsDocument",
      type: [".xlxs", ".xls"],
    },

    {
      title: "Release Manager Sign Off",
      value: "releaseManagerSignOffDocument",
      type: ".msg",
    },
    { title: "Gate Form", value: "gateFormDocument", type: [".xlxs", ".xls"] },
    {
      title: "Peer Review Checklist",
      value: "peerReviewchecklistDocument",
      type: [".xlxs", ".xls"],
    },
    { title: "QA Sign Off", value: "qaSignOffDocument", type: ".msg" },
    {
      title: "Walk Through Video",
      value: "walkthroughVideo",
      type: [".mov", ".mp4", ".avi"],
    },
    { title: "KT Video", value: "ktVideo", type: [".mov", ".mp4", ".avi"] },
  ];

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const softSkillID = params.get("softSkillID");
  //console.log(softSkillID);
  const [documentTypes, setDocumentTypes] = useState([]);

  React.useEffect(() => {
    //console.log("mybotUse Effect");
    //console.log("auth --mybot", auth);
    //console.log("mybotUse", myBot);
    if (myBot != null) {
      //console.log("Restricted User", restrictedUser);
      if (myBot.businessOwnerEmailID == auth.email) {
        setRestrictedViewDetails(false);
      } else if (restrictedUser.includes(auth.userType)) {
        setRestrictedViewDetails(true);
      } else {
        setRestrictedViewDetails(false);
      }
      //console.log("my bot bot detail end user ---", myBot);
      let documentsToSet = [];
      for (let i in documentAr) {
        {/*console.log(
          "My bot document value  ---",
          myBot[documentAr[i]["value"]]
        );*/}
        if (
          myBot[documentAr[i]["value"]] !== undefined &&
          myBot[documentAr[i]["value"]] !== null &&
          myBot[documentAr[i]["value"]] !== "" &&
          myBot[documentAr[i]["value"]] !== "can be empty"
        ) {
          //console.log("what Input doc-----", myBot[documentAr[i]["value"]]);
          documentsToSet.push(documentAr[i].title);
        }
      }
      // if (myBot.botDemoVideo != undefined && myBot.botDemoVideo !== "" && myBot.botDemoVideo != undefined) {
      //   documentsToSet.push("Bot Demo Vedio");
      // }
      //console.log(documentsToSet, "DOCumentstoset");
      if (restrictedUserDocumentView.includes(auth.userType)) {
        if (auth.userType == "businessOwner") {
          //console.log(myBot.businessOwnerEmailID, "DOCumentstoset");
          //console.log(auth.email, "DOCumentstoset");
          if (myBot.businessOwnerEmailID == auth.email) {
            //console.log(documentsToSet, "DOCumentstoset");
            setDocumentTypes([...documentsToSet]);
          } else {
            let restrictedNewDocumented = [];
            if (documentsToSet.includes("SOP")) {
              restrictedNewDocumented.push("SOP");
            }
            if (documentsToSet.includes("PDD")) {
              restrictedNewDocumented.push("PDD");
            }

            setDocumentTypes(restrictedNewDocumented);
          }
        } else {
          let restrictedNewDocumented = [];
          if (documentsToSet.includes("SOP")) {
            restrictedNewDocumented.push("SOP");
          }
          if (documentsToSet.includes("PDD")) {
            restrictedNewDocumented.push("PDD");
          }

          setDocumentTypes(restrictedNewDocumented);
        }
      } else {
        setDocumentTypes(documentsToSet);
      }
    }
  }, [myBot]);

  const [restrictedUser, setRestrictedUser] = useState([
    "endUser",
    "businessUserRegionWise",
    "businessOwner",
    "firstGfcf",
    "gfcf",
    "firstLevelGPMApprover",
    "GPMapprover",
    "gCad",
    "infosec",
    "landscape",
  ]);
  const [allFieldsUserType, setallFieldsUserType] = useState([
    "internalUser",
    "support",
    "releaseManager",
    "editAccess",
    "admin",
  ]);

  const [editUser, setEditUser] = useState([
    "internalUser",
    "admin",
    "qrManager",
    "releaseManager",
    "supportStatus",
  ]);

  const [botModal, setbotModal] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [bots, setBots] = React.useState([]);
  const [successModal, setSuccessModal] = React.useState(false);
  const [documentDropdown, setDocumentDropdown] = React.useState(false);
  const [selectedDropdown, setSelectedDropdown] = React.useState("sopDocument");
  const [similarBots, setSimilarBots] = React.useState([]);
  const [currentDocumentExtension, setCurrentDocumentExtension] =
    React.useState("pdf");
  const [searchResults, setSearchResults] = React.useState(false);
  const [documentEditState, setDocumentEditState] = React.useState(false);
  const [editedDocument, setEditedDocument] = React.useState("");
  const [editLoader, setEditLoader] = React.useState(false);
  const [invalidModal, setInvalidModal] = React.useState(false);
  const [skilldetails, setSkilldetails] = React.useState([]);

  const getData = async () => {
    axios({
      method: "get",
      url: `${endpoints.baseUrl}/softSkill/get?softSkillID=${softSkillID}`,
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
    }).then((resp) => {
      setSkilldetails(resp.data.data);
    });
  };

  React.useEffect(() => {
    getData();
  }, []);
  //console.log("skilldetails", skilldetails);

  React.useEffect(() => {
    //console.log(currentDocumentExtension, "currentDocument");
  }, [currentDocumentExtension]);

  let auth = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");
  const openDocumentSelector = () => {
    setDocumentDropdown(!documentDropdown);
  };

  const [authData, setAuthData] = useState("");
  React.useEffect(async () => {
    let authCheck = _.get(JSON.parse(localStorage.getItem("auth")), "data", "");

    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      fetchbot(auth);
    } else {
      setLoading(false);
      props.sessionTimeOutCheck(true);
    }

    if (router.query.searchResults) {
      setSearchResults(true);
    }
  }, [router.query]);

  const fetchbot = async (auth) => {
    setAuthData(auth);
    if (router.query.botID) {
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        axios({
          method: "get",
          url: `${endpoints.baseUrl}/bot/getBotUsingId?botID=${window.atob(
            router.query.botID
          )}`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data) {
              if (res.data.data.dateOfStatusChanged) {
                res.data.data.dateOfStatusChanged =
                  res.data.data.dateOfStatusChanged.slice(0, 10);
              }
            }

            setMyBot(res.data.data);
            let initialExtensionAr = res.data.data.sopDocument.split(".");

            //console.log(initialExtensionAr, "initialExtensionAr");

            dispatch(saveCurrentBot(res.data.data));
            setLoading(false);
            if (initialExtensionAr.length > 1) {
              setCurrentDocumentExtension(
                initialExtensionAr[initialExtensionAr.length - 1]
              );
            }

            // if (res.data.data && (res.data.data.documentLink || res.data.data.path)) {
            //   setEditedDocument(res.data.data.documentLink ? res.data.data.documentLink : res.data.data.path)
            // }
            // fetching similar bots
            axios({
              method: "get",
              url: `${endpoints.baseUrl}/elastic/searchQuery`,
              params: { leadPlatform: res.data.data.leadPlatform },
              headers: {
                Authorization: `${auth.accessToken}|${auth.email}`,
              },
            }).then((resp) => {
              if (resp.data.code == 200) {
                //console.log("response of similar bots elastic");

                setSimilarBots(
                  resp.data.data.allBots.filter(
                    (item) => item._source.botID != res.data.data.botID
                  )
                );

                // dispatch(saveBotsAction({ data: resp.data.data, filter: "filter" }));
              } else if (resp.data.code == 403) {
                localStorage.removeItem("auth");
                sessionStorage.clear();
                // router.push("/login");
                setLoading(false);
                props.sessionTimeOutCheck(true);
              }
            });
          } else if (res.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            // router.push("/login");
            setLoading(false);
            props.sessionTimeOutCheck(true);
          }
        });
      } else {
        setLoading(false);
        props.sessionTimeOutCheck(true);
      }
    }
  };

  const frameRef = React.useRef(null);

  React.useEffect(() => {
    //console.log("myBot_Props", props);
    if (props.type == "previewPage") {
      setMyBot(props.myBot);
      setLoading(false);
      let initialExtensionAr = props.myBot.sopDocument.split(".");
      //console.log(initialExtensionAr, "initialExtensionAr");
      if (initialExtensionAr.length > 1) {
        setCurrentDocumentExtension(
          initialExtensionAr[initialExtensionAr.length - 1]
        );
      }
    }

    if (frameRef.current != null) {
      frameRef.current.contentWindow.location.reload();
    }

    //console.log(document.getElementById("youriframe"), "youriframe");
    //console.log(frameRef, "youriframe");
  }, []);

  const getBot = () => {
    let modal = !botModal;
    setbotModal(true);

    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const editBot = () => {
    router.push("/editBot");
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    // console.log(documentAr, "DOCUMENTAR")
    // console.log(value,"valueee")
    let selectedDocument = documentAr.filter(
      (item, index) => item.title == value
    );
    // console.log(selectedDocument[0].value, "selected Dropdown")
    setSelectedDropdown(selectedDocument[0].value);
    //console.log(myBot[selectedDocument[0].value], "ye value check karne ka");
    //console.log(myBot[selectedDocument[0].value], "valueeeeesss");
    let extensionAr = myBot[selectedDocument[0].value].split(".");
    let extension = extensionAr[extensionAr.length - 1];
    setCurrentDocumentExtension(extension);
    setDocumentDropdown(false);
  };

  function camelize(str) {
    if (str === undefined) {
      return null;
    } else {
      return str
        .toString()
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
    }
  }

  const fixCountry = (str) => {
    let fixedString = "";

    if (props.type == "previewPage") {
      //     for (let i in str) {
      //       if (i != str.length-1){
      //         fixedString = fixedString + str[i] + ", ";
      //       }
      //       else {
      //         fixedString = fixedString+ str[i]
      //       }
      //     }
    } else {
      if (str.includes(";")) {
        str.replace(";", ",");
      }
    }

    if (fixedString[fixedString.length - 1] == ",") {
      fixedString = fixedString.slice(0, fixedString.length - 1);
    }

    return fixedString;
  };

  const changeDocumentLink = async () => {
    //console.log(editedDocument, "editedDocument");

    if (editedDocument.trim()) {
      setEditLoader(true);
      let auth = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(auth);

      if (expiryStatus) {
        let res = await axios({
          method: "PUT",
          data: {
            botID: myBot.botID,
            newDocumentLink: editedDocument,
          },
          url: `${endpoints.baseUrl}/bot/editDocumentLink`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        });
        setMyBot(res.data.data);
        let initialExtensionAr = res.data.data.sopDocument.split(".");

        //console.log(initialExtensionAr, "initialExtensionAr");

        dispatch(saveCurrentBot(res.data.data));
        setDocumentEditState(false);
        setEditLoader(false);
      } else {
        setLoading(false);
        props.sessionTimeOutCheck(true);
      }
    } else {
      setInvalidModal(true);
    }
  };
  let getCurrentExtension, fetchURL;
  return (
    <>
      {successModal ? <SuccessModal setSuccessModal={setSuccessModal} /> : null}
      {invalidModal ? (
        <SuccessModal
          setSuccessModal={setInvalidModal}
          title={"Edit document link"}
          message={"Document link cannot be empty"}
          fail={true}
        />
      ) : null}

      <div className="container">
        {skilldetails.map((item, index) => {
          const {
            Profile,
            businessRequestorEmail,
            createdAt,
            employeeTwinID,
            skillDescription,
            skillName,
            softSkillID,
            status,
            sopDocument,
            engagementLeadEmail,
            updatedAt,
          } = item;
          {
            {/* fetchURL = `https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/ETTaskBreaks.xlsx`; */}
            getCurrentExtension = path.extname(sopDocument).substring(1);
            //console.log("getCurrentExtension", getCurrentExtension);
          }
          return (
            <div key={index} className={styles.botDetailWrapper}>
              <div className={styles.detailHead}>
                <div className={styles.cardHead}>
                  <div className={styles.left}>
                    <div className={`${styles.dollarBack}`}>
                      <span
                        className={styles.rollBot}
                        onClick={() => {
                          router.push("/botStore");
                        }}
                      >
                        <img
                          src={
                            "https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/lessthan.png"
                          }
                        />
                      </span>
                      <div className={`${styles.icon} Iconimage`}>
                        <div className={`${styles.dollaricon}`}>
                          <span className={`${styles.dollarspan}`}>$</span>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.text}`}>
                      <div className={styles.flexd}>
                        <p className={styles.code}>{softSkillID}</p>
                      </div>
                      {skillName}
                    </div>
                    <div className={`${styles.statusTagWrapper}`}>
                      <p className={`${styles.label} ${styles.liveStatus}`}>
                        {" "}
                        {status}{" "}
                      </p>
                    </div>
                  </div>

                  {/* <div className={styles.right}>

                  <div>
                    <span className={styles.backBot}>
                      Create Roll Out Bot
                    </span>
                  </div>
                  <span className={styles.getBot} onClick={getBot}>
                    Get This Bot
                  </span>
                </div> */}
                </div>
              </div>

              <div className={styles.detailBody}>
                <div className={styles.textualContent}>
                  <div className={styles.txtCard}>
                    <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                      <div className={styles.left}>
                        <p>Profile</p>
                        {Profile}
                      </div>
                      <div className={styles.right}>
                        <p>EmployeeTwin ID</p>
                        {employeeTwinID}
                      </div>
                    </div>

                    <div className={`${styles.cardRow} ${styles.fullwidth}`}>
                      <div className={styles.center}>
                        <p>Soft Skill DESCRIPTION</p>
                        {skillDescription}
                      </div>
                    </div>

                    <div className={`${styles.cardRow}`}>
                      <div className={styles.left}>
                        <p>Status</p>
                        {status}
                      </div>
                      <div className={styles.right}>
                        <p>Upload Document</p>
                        {sopDocument}
                      </div>
                    </div>

                    <div className={`${styles.cardRow}`}>
                      <div className={styles.left}>
                        <p>CREATED AT</p>
                        {createdAt}
                      </div>
                      <div className={styles.right}>
                        <p>BUSINESS OWNER E-MAIL ID</p>
                        {businessRequestorEmail}
                      </div>
                    </div>

                    <div className={`${styles.cardRow}`}>
                      <div className={styles.left}>
                        <p>EBGAGMENT LEAD</p>
                        {engagementLeadEmail}
                      </div>

                      <div className={styles.right}>
                        <p>Updated At</p>
                        {updatedAt}
                      </div>
                    </div>

                    {restrictedUserDocumentView.includes(
                      auth.userType
                    ) ? null : (
                      <div
                        className={`${styles.cardRow} ${styles.fullwidth}`}
                      ></div>
                    )}
                  </div>
                </div>
                <div className={styles.mediaContent}>
                  {/* <div className={styles.videWrapper}>
                      <ReactPlayer
                        width="100%"
                        height="100%"
                        controls
                        url={`${endpoints.fetchBlobUrl}/botDocuments/${myBot.documentFolderName}/${myBot.botDemoVideo}`}
                      />
                    </div> */}

                  <div className={styles.pdfWrapper}>
                    <div className={styles.pdfHead}>
                      <p className={styles.pdfText}>Documents</p>

                      <div
                        className={styles.threeDots}
                        // onClick={openDocumentSelector}
                      >
                        <Icons name="threeDots" className={styles.plusIcon} />
                      </div>
                    </div>
                    {documentDropdown ? (
                      <div className={styles.dropdownWrapper}>
                        <div className={styles.dropdown}>
                          <Dropdown
                            dropdownParent="documentType"
                            values={documentTypes}
                            getDropdownValue={gotDropDownValue}
                            haveRelated={null}
                            params="botDetailDocument"
                            closeAllDropdowns={() => setDocumentDropdown(false)}
                          />
                        </div>
                      </div>
                    ) : null}

                    <div className={styles.pdfsubHead}>
                      <Icons
                        name={currentDocumentExtension}
                        className={styles.icon}
                      />
                      <p className={styles.pdfText}>
                        Document
                      </p>
                      <div
                        onClick={() => {
                          // window.open(`${fetchURL}`);
                          window.open("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/"+`${sopDocument}`);
                        }}
                        className={styles.downloadIcon}
                      >
                        <Icons name="downloadBlue"></Icons>
                      </div>
                    </div>
                    <div className={styles.pdfmainHead}>
                      
                      <iframe
                        // src="https://docs.google.com/viewerng/viewer?embedded=true&url=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/ETTaskBreaks.xlsx"
                        ref={frameRef}
                        src={
                          (
                          getCurrentExtension == "jpg" ||
                          getCurrentExtension == "mp4"||
                          getCurrentExtension == "gif"
                            ? `https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/${sopDocument}`
                            : getCurrentExtension == "xlsx" ||
                            getCurrentExtension == "pdf" ||
                              getCurrentExtension == "xls" ||
                              getCurrentExtension == "doc" ||
                              getCurrentExtension == "docx"
                            ? `https://docs.google.com/viewerng/viewer?embedded=true&url=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/${sopDocument}`
                            : getCurrentExtension == "ppt" ||
                              getCurrentExtension == "pptx" ||
                              getCurrentExtension == "msg"
                            ? `https://view.officeapps.live.com/op/embed.aspx?src=https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/${sopDocument}`
                            : `https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/${sopDocument}`) +
                          `?ignore= ${Math.floor(Math.random() * 1000)}`
                        }
                        type={`application/${getCurrentExtension}`}
                        width="100%"
                        height="532px"
                        //  border="none"
                      ></iframe>
                      
                      {/* <iframe className={styles.icard}
                    src={`https://newbotstore.blob.core.windows.net/botstorevideo/${myBot.sopDocument}`}
                    width="420"
                    height="500"
                  ></iframe> */}
                    </div>

                    {/* <span
                          style={{
                            position: "absolute",
                            marginLeft: "200px",
                            marginTop: "200px",
                          }}
                        >
                          Does not exist
                        </span> */}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
    tokenStatus: state.session.token,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

